/* tslint:disable */
/* eslint-disable */
/**
 * B2B Ground
 * Ground API  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.volume`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.ground.autoComplete.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.ground.autoComplete.success`   * tags: `api_version`, `tenantid` * `b2bportal.ground.shop.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.ground.shop.success`   * tags: `api_version`, `tenantid` * `b2bportal.ground.singleItinerary.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.ground.singleItinerary.success`   * tags: `api_version`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.cancel.product.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.quote.cancel.product.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `advance_lead_time` * `age_requirement` * `bad_request` * `duplicate_booking` * `internal_error` * `invalid_loyalty_number` * `overlapping_reservation` * `price_change` * `rate_unavailable` * `request_deserialization_error` * `response_serialization_error` * `rewards_not_found` * `unknown`  # Tracking Error Codes * `bad_request` * `internal_cancel_error$` * `product_failure` * `refund_failure` * `request_deserialization_cancel_error$` * `response_serialization_error` * `schedule_failure` * `unknown`  # Cancel Scenarios * `canceled` * `contact_customer_service` * `fully_refundable` * `non_refundable` * `pending`  
 *
 * The version of the OpenAPI document: v1p1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
}
